<template>
    <div>
      <v-main>
        <div
          class="col-md-12 ml-sm-auto col-lg-12 pa-4"
          v-show="dataintab === true"
        >
          <v-row class="pb-3">
            <v-col>
              <h2>รายงานแจ้งเตือนล่วงหน้าวันเกิด</h2>
            </v-col>
            <!-- <v-col class="text-right mb-4">
              <v-btn
              class="btn-color"
                v-bind="attrs"
                v-on="on"
              >
              <p class="mb-0" style="color: white">Export Data</p>
              <download-excel
                      class="btn btn-default text-white"
                      :data="dataItem3"
                      :fields="export_fields"
                      :type="exportType"
                      :worksheet="exportWorksheet"
                      :name="exportFileName"
                    >
                    <v-icon style="color:rgb(255 255 255);"> mdi-download </v-icon>
                </download-excel>
              </v-btn>
            </v-col> -->
          </v-row>

          <v-card>
            <v-data-table
                :headers="headers"
                :items="data_notify"
                :items-per-page="5"
                class="elevation-1"
            >
            <template v-slot:[`item.CREATE_DATE`]="{ item }">
                {{ thaiFormattedDate(item.CREATE_DATE) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" dark class="btn-color" fab x-small @click.stop="
                            (dialogData = true),
                            getMember(item);">
                            <v-icon dark> mdi-account </v-icon>
                          </v-btn>
                        </template>
                        <span>ดูข้อมูล</span>
                      </v-tooltip>
                    </template>
            </v-data-table>
          </v-card>
        </div>
        <v-dialog v-model="dialogData"  max-width="50%" content-class="dialog-pin-top">
            <v-card max-width="100%">
                <v-row style="padding-top:15px;padding-right:15px">
                    <v-col><h3 style='padding-left: 10px;padding-top: 10px;'>รายชื่อคนที่ส่งแจ้งเตือน</h3></v-col>
                    <v-col cols="12" sm="5">
                      <v-text-field
                        v-model="memberSearch"
                        label="ค้นหา ชื่อ / เบอร์โทร"
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        dense
                        clearable
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click=";(dialogData = false)"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn></v-col>
                </v-row>
                <v-data-table
                :headers="headers1"
                :items="Listmember"
                :search="memberSearch"
                :custom-filter="memberFilter"
                :items-per-page="5"
                class="elevation-1"
            >
            <template v-slot:[`item.birthDay`]="{ item }">
                {{ thaiFormattedDate(item.birthDay) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" dark class="btn-color" fab x-small @click.stop="
                            (dialogData = true),
                            getMember(item);">
                            <v-icon dark> mdi-account </v-icon>
                          </v-btn>
                        </template>
                        <span>ดูข้อมูล</span>
                      </v-tooltip>
                    </template>
            </v-data-table>
            </v-card>
        </v-dialog>
      </v-main>
    </div>
  </template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx'
import memberSearch from '@/mixins/memberSearch'
export default {
  mixins: [memberSearch],
  watch: {
    // ปิดป๊อปอัปรายชื่อแล้วล้างคำค้น เปิดรายการถัดไปจะได้ไม่ถูกกรองค้าง
    dialogData (open) {
      if (!open) this.memberSearch = ''
    }
  },
  components: {
    moment,
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {

      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: 1
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: 1
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: 7
        }
      ],
      menu: false,
      PK: '',
      path: '/package/', // Path Model
      PATH: '/packageQRcode/',
      returnLink: '/Master/Package',
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      menu1: false,
      dataintab: true,

      columns: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'แพ็กเกจ', value: 'packageName' },
        {
          text: 'จำนวนการใช้งาน/ครั้ง',
          value: 'packageCount',
          align: 'center'
        },
        { text: 'ราคา', value: 'packagePrice', align: 'center' },
        { text: 'คะแนนที่ได้ต่อครั้ง', value: 'packagePoint', align: 'center' },
        { text: 'รายละเอียด', value: 'packageDetail' },
        { text: 'อายุการใช้งาน', value: 'packageExpridate', align: 'center' }
      ],
      itemExpri: [
        { text: '3 เดือน', value: '3' },
        { text: '6 เดือน', value: '6' },
        { text: '9 เดือน', value: '9' },
        { text: '1 ปี', value: '12' }
      ],
      columns1: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'แพ็กเกจ', value: 'packageName' },
        {
          text: 'จำนวนการขาย',
          value: 'count',
          align: 'center'
        },
        {
          text: 'ลูกค้าที่ซื้อแพ็กเกจ',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      dataItem1: [],
      columns2: [
        { text: 'รูป', value: 'picture' },
        { text: 'ชื่อไลน์ลูกค้า', value: 'name' },
        { text: 'แพ็กเกจ', value: 'packageName' },
        {
          text: 'จำนวนครั้งที่ใช้ได้',
          value: 'amount',
          align: 'center'
        },
        {
          text: 'จำนวนครั้งที่เหลือ',
          value: 'balanceAmount',
          align: 'center'
        },
        {
          text: 'วันหมดอายุ',
          value: 'exPackage',
          align: 'center'
        }
      ],
      dataItem2: [],
      dataItem3: [],
      date: [],
      menu2: false,
      idPackage: '',
      nameSearch: '',
      exportType: 'xls',
      exportFileName: 'Report_Birthday',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        ชื่อไลน์: 'name',
        ชื่อ: 'nameCustomer',
        ชื่อแพ็กเกจ: 'packageName',
        ราคาแพ็กเกจ: 'packagePrice',
        จำนวนทั้งหมด: 'amount',
        จำนวนที่เหลือ: 'balanceAmount',
        วันหมดอายุแพ็กเกจ: 'packageExpire'
      },

      data_notify: [],
      headers: [
        {
          text: 'วันที่แจ้งเตือน',
          value: 'CREATE_DATE'
        },
        { text: 'รายชื่อ', value: 'action', sortable: false, align: 'center' }
      ],
      Listmember: [],
      headers1: [
        {
          text: 'ชื่อ',
          value: 'name'
        },
        {
          text: 'เบอร์โทรศัพท์',
          value: 'tel'
        },
        {
          text: 'วันเกิด',
          value: 'birthDay'
        },
        {
          text: 'คะแนนคงเหลือ',
          value: 'currentPoint'
        }
        // { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dialogData: false

    }
  },
  computed: {
    dateRangeText () {
      return this.date.join(' - ')
    }
  },

  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.getNotify()
    this.generateFileName()
  },
  methods: {
    generateFileName () {
      const date = moment().format('DDMMYYYY')
      this.exportFileName = `Report_Birthday_${date}.xls`
    },
    getNotify () {
      this.data_notify = []
      axios
        .get(this.DNS_IP + '/Log_Notify_Birthday/get?shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          console.log('s', res.data.length)
          if (res.data.length > 0) {
            this.data_notify = res.data
            console.log(this.data_notify)
          } else {
            this.data_notify = []
          }
        }

        )
    },
    getMember (item) {
      console.log(item)
      this.Listmember = JSON.parse(item.member)
      console.log(this.Listmember[0].name)
    }
  }
}
</script>
  <style scoped>
  h3 {
    font-size: 18.72px !important;
  }
  </style>
CREATE_DATE
:
(...)
CREATE_USER
:
(...)
LAST_DATE
:
(...)
LAST_USER
:
(...)
RECORD_STATUS
:
(...)
id
:
(...)
member
:
"[{\"memberId\": \"1707659815811\", \"memberCardId\": \"MC1707659815811\", \"lineUserId\": \"LUa6d5013c28753df851958a420df42ebb-Ud24ed731982ccf4a47a3476b3627a5e6\", \"name\": \"u0e21u0e42u0e19u0e23u0e21u0e22u0e4c u0e41u0e01u0e48u0e19u0e17u0e2du0e07\", \"picture\": \"https://profile.line-scdn.net/0hR2jkai8nDR1HEh4brhdzYjdCDndkY1QPPH1GfCcVUn97J0sePHFLL3QRASp6IUsYYnFHKHMVVypLAXp7WUTxKUAiUCx7IEtOan1D-g\", \"gender\": \"male\", \"nameCustomer\": \"u0e21u0e42u0e19u0e23u0e21u0e22u0e4c u0e41u0e01u0e48u0e19u0e17u0e2du0e07\", \"shopId\": \"Ud24ed731982ccf4a47a3476b3627a5e6\", \"RECORD_STATUS\": \"N\", \"CREATE_DATE\": \"Sun, 11 Feb 2024 20:56:55 GMT\", \"first_time_get_point\": null, \"CREATE_USER\": \"U8bf3b89206cac5b806b02e8e8b6bac86\", \"LAST_DATE\": \"Sun, 11 Feb 2024 20:57:04 GMT\", \"LAST_USER\": \"LUa6d5013c28753df851958a420df42ebb-Ud24ed731982ccf4a47a3476b3627a5e6\", \"CONDITION_TERM2\": \"True\", \"totalPoint\": 0, \"LevelName\": \"Member\", \"pictureUrl\": \"https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/Card.png?alt=media&token=beb761a8-2049-4b90-b470-d6ec6467ec5c\", \"priviledge\": null, \"color\": \"#B9725B\", \"frameNo\": null, \"regisCustomFeild\": null, \"levelId\": \"1421\", \"lastUpdateCard\": \"Tue, 09 Apr 2024 22:41:40 GMT\", \"tel\": \"0924259530\", \"birthDay\": \"1992-04-11\", \"age\": 32, \"liffUserId\": \"U8bf3b89206cac5b806b02e8e8b6bac86\", \"lineUserIdVLinked\": null, \"collectPoint\": 0, \"redeemPoint\": 0, \"lastProductExchangeRateId\": null, \"lastBranch\": null, \"currentPoint\": 0, \"before_img\": null, \"after_img\": null, \"language\": \"th\", \"barcodeNum\": null, \"pin_number\": null}, {\"memberId\": \"1708330632196\", \"memberCardId\": \"MC1708330632196\", \"lineUserId\": null, \"name\": \"casper\", \"picture\": \"https://profile.line-scdn.net/0hn7hmUTSXMRhFFBhnpXBPZzVEMnJmZWgKbHt3dnBDbX96c3BJanp3eSJHaiwrcXdLPSB7dnREantJB0Z-W0LNLEIkbCl5JndLaHt__w\", \"gender\": \"female\", \"nameCustomer\": \"CASPER\", \"shopId\": \"Ud24ed731982ccf4a47a3476b3627a5e6\", \"RECORD_STATUS\": \"N\", \"CREATE_DATE\": \"Mon, 19 Feb 2024 15:17:12 GMT\", \"first_time_get_point\": null, \"CREATE_USER\": \"Uac5c321a0dd0bc1557052e07e879dfa4\", \"LAST_DATE\": \"Mon, 19 Feb 2024 15:17:19 GMT\", \"LAST_USER\": \"Uac5c321a0dd0bc1557052e07e879dfa4\", \"CONDITION_TERM2\": \"True\", \"totalPoint\": 0, \"LevelName\": \"Member\", \"pictureUrl\": \"https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/Card.png?alt=media&token=beb761a8-2049-4b90-b470-d6ec6467ec5c\", \"priviledge\": null, \"color\": \"#B9725B\", \"frameNo\": null, \"regisCustomFeild\": null, \"levelId\": \"1421\", \"lastUpdateCard\": \"Tue, 09 Apr 2024 22:39:51 GMT\", \"tel\": \"0950503730\", \"birthDay\": \"1995-04-11\", \"age\": 29, \"liffUserId\": \"Uac5c321a0dd0bc1557052e07e879dfa4\", \"lineUserIdVLinked\": null, \"collectPoint\": 0, \"redeemPoint\": 0, \"lastProductExchangeRateId\": null, \"lastBranch\": null, \"currentPoint\": 0, \"before_img\": null, \"after_img\": null, \"language\": \"th\", \"barcodeNum\": null, \"pin_number\": null}]"
shopId
:
(...)



// WEBPACK FOOTER //
// src/components/Reports/reportNotifyBirthDay.vue